module.exports = __webpack_public_path__ + "static/media/four.640a95da.svg";